import { type ReactElement, useState } from 'react'
import { useApplicationsDetails } from '../queries/useApplicationsDetails'
import { ApplicationModal } from './ApplicationModal'
import { getApplicationModalGlobalRef } from './applicationModalRef'

export const ApplicationModalGlobal = (): ReactElement | null => {
  const [applicationId, setApplicationId] = useState<number | null>(null)
  const [applicationIds, setApplicationIds] = useState<number[]>([])

  getApplicationModalGlobalRef().current = (
    applicationId: number,
    applicationIds: number[]
  ) => {
    setApplicationId(applicationId)
    setApplicationIds(applicationIds)
    return true
  }

  // Loaded so the previous/next buttons can label themselves with the applicant names
  const { applications } = useApplicationsDetails(applicationIds)

  if (applicationId === null) {
    return null
  }

  return (
    <ApplicationModal
      defaultApplicationId={applicationId}
      // Until every application is loaded the opened one may be missing, and findIndex would then
      // resolve the next application to the first of the collection
      collection={
        applications.some(({ id }) => id === applicationId)
          ? applications
          : undefined
      }
      showOrder
      onClose={() => {
        setApplicationId(null)
        setApplicationIds([])
      }}
    />
  )
}
